exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loader-spinner {\n    margin: 0% 40%;\n}\n\n.loader-container {\n    text-align: center;\n    padding: 20% 20% !important;\n\n}\n\n.outlined {\n    outline: 2px dashed dimgray !important;\n    outline-offset: -10px !important;\n}\n\n.modal-content {\n    border-radius: 10px !important;\n}", ""]);

